import { IIcon, IIndexable } from '../interfaces';
import { getRandomInt } from './math-provider';

export const TABLER_ICON_WIDTH = 24;
export const TABLER_ICON_HEIGHT = 24;

export const getRandomIcon = async (iconsData: IIndexable, category: string) : Promise<IIcon> => {

    let keys: string[] = [];

    if(category){
        const temp = Object.keys(iconsData);
        for(let i=0; i<temp.length; i++){
            const tempKey = temp[i];
            const item = iconsData[tempKey];
            if(item.category === category){
                keys.push(tempKey);
            }
        }
    }
    else{
        keys = Object.keys(iconsData);
    }

    const randomIndex = getRandomInt(0, keys.length - 1);
    const iconKey = keys[randomIndex];
    const icon = iconsData[iconKey];

    const url = `tabler-icons/icons/${ iconKey }.svg`;
    const response = await fetch(url);
    const svg = await response.text()

    return {
        svg,
        iconKey,
        category: icon.category,
    }
};

export const getRandomIcons = async (
    iconsData: IIndexable,
    category: string,
    randomIconsCount: number
) : Promise<IIcon[]> => {
    const icons:IIcon[] = [];

    for(let i=0; i<randomIconsCount; i++){
        const icon = await getRandomIcon(iconsData, category);
        icons.push(icon);
    }

    return icons;
};